import React, { Component, PropTypes } from 'react';
import {connect} from 'react-redux';
import styles from './MainPageCategoriesGrid.scss';
import _ from 'lodash';
import Category from './MainPageCategory';
import MobileCategoriesGrid from './MobileCategoriesGrid';
import Media from 'react-responsive';


export class MainPageCategoriesGrid extends Component {
  render() {
    const categories = _.map(this.props.categories, (cat) => (
      <Category key={`cat_${cat.name}`} {...cat} />
    ));
    return (
      <div className={ styles.gridContainer }>
        <Media query="(min-width: 1025px)">
          <div className={ styles.gridWrapper }>
            {categories}
          </div>
        </Media>
        <Media query="(max-width: 1024px)">
          <MobileCategoriesGrid items={categories} />
        </Media>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    categories: state.appReducer.mainPageCategories
  };
}

export default connect(
  mapStateToProps,
  () => ({})
)(MainPageCategoriesGrid);



/** WEBPACK FOOTER **
 ** ./src/components/MainPage/elements/MainPageCategoriesGrid.jsx
 **/